import { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { BiUser } from "react-icons/bi";
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/* ================= DATA ================= */

const testimonials = [
  {
    name: "Chetan Poojary",
    channel: "Arena",
    review:
      "Great buying experience. Also, they under promised and over delivered on delivery, discount and other commitments. Mr. Veerendra was my sales contact and provided excellent service.",
  },
  {
    name: "Ramya",
    channel: "NEXA",
    review:
      "Overall experience is excellent. The executives were friendly and easy to connect throughout the entire purchase process.",
  },
  {
    name: "Chetan Poojary",
    channel: "Arena",
    review:
      "Highly recommended if you are planning for a Maruti Suzuki car.",
  },
  {
    name: "Ramya",
    channel: "NEXA",
    review:
      "Smooth process, transparent pricing and great support.",
  },
];

/* ================= COMPONENT ================= */

export const Testimonials = () => {
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  /* 🔑 IMPORTANT: bind navigation AFTER render */
  useEffect(() => {
    if (
      swiperRef.current &&
      prevRef.current &&
      nextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section
      className="relative py-16 sm:py-20 lg:py-28 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://imgd.aeplcdn.com/664x374/n/cw/ec/194921/victoris-exterior-right-front-three-quarter-7.jpeg?isig=0&q=80')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/80"></div>

      <div className="relative z-10 px-4 sm:px-6 max-w-7xl mx-auto">
        {/* Title */}
        <h3 className="text-2xl sm:text-3xl lg:text-4xl text-white text-center font-semibold">
          Testimonials
        </h3>
        <div className="bg-red-600 h-1 w-36 mx-auto mt-3 rounded-full"></div>

        {/* SLIDER */}
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop
          centeredSlides
          spaceBetween={40}
          pagination={{ clickable: true }}
          // navigation={true}
          breakpoints={{
            320: { slidesPerView: 1, centeredSlides: false },
            768: { slidesPerView: 1.15, centeredSlides: true },
            1024: { slidesPerView: 1.4 },
            1280: { slidesPerView: 1.6 },
          }}
          className="mt-10 sm:mt-14"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
                <div
                  className={`transition-all duration-500 ${
                    isActive
                      ? "opacity-100 scale-100"
                      : "opacity-40 scale-90"
                  }`}
                >
                  <TestimonialCard {...item} />
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        {/* NAV BUTTONS */}
        <button
          ref={prevRef}
          className="hidden sm:flex absolute left-2 top-1/2 -translate-y-1/2
          z-30 w-12 h-12 rounded-full bg-white/20 hover:bg-white/40
          items-center justify-center text-white transition"
        >
          <FaChevronLeft size={18} />
        </button>

        <button
          ref={nextRef}
          className="hidden sm:flex absolute right-2 top-1/2 -translate-y-1/2
          z-30 w-12 h-12 rounded-full bg-white/20 hover:bg-white/40
          items-center justify-center text-white transition"
        >
          <FaChevronRight size={18} />
        </button>
      </div>
    </section>
  );
};

/* ================= CARD ================= */

const TestimonialCard = ({ name, channel, review }) => {
  return (
    <div className="relative max-w-6xl mx-auto px-2 sm:px-4">
      <div className="relative bg-[#234E86] text-white px-6 sm:px-8 py-6 sm:py-8 rounded-sm">
        <FaQuoteLeft className="text-3xl sm:text-4xl opacity-90 mb-4" />
        <p className="text-sm sm:text-base leading-relaxed font-light">
          {review}
        </p>

        {/* Bubble Arrow */}
        <div
          className="absolute -bottom-4 left-10 w-0 h-0
          border-l-[16px] border-l-transparent
          border-r-[16px] border-r-transparent
          border-t-[16px] border-t-[#234E86]"
        />
      </div>

      {/* User */}
      <div className="flex items-center gap-4 mt-6 ml-6">
        <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center border-4 border-[#234E86]">
          <BiUser size={26} className="text-black" />
        </div>

        <div>
          <p className="text-white font-semibold">{name}</p>
          <p className="text-gray-300 text-sm">{channel}</p>
        </div>
      </div>
    </div>
  );
};
